export interface FieldIds {
  hintId: string;
  errorId: string;
  /** Value for the control's `aria-describedby`, or `undefined` if unneeded. */
  describedBy: string | undefined;
}

/** Derives the ARIA wiring between a control and its hint/error text. */
export function getFieldIds(id: string, hint?: string, error?: string): FieldIds {
  const hintId = `${id}-hint`;
  const errorId = `${id}-error`;
  const ids = [hint ? hintId : null, error ? errorId : null].filter(Boolean);

  return { hintId, errorId, describedBy: ids.length > 0 ? ids.join(' ') : undefined };
}
